import * as rows from 'common/constants/financials';

const HEADER_CLASSNAME = 'table-header division-bottom-only';

const baseRowConfig = [
  {
    alias: rows.FIRST_ROW_ALIAS,
    className: HEADER_CLASSNAME,
    dbType: 'string',
    gridType: 'string',
    hidden: false,
    ignoreExpr: true,
    isTitleOrHeader: true,
    readOnly: true,
    value: rows.FIRST_ROW_TITLE,
  },
  {
    alias: rows.SECOND_ROW_ALIAS,
    className: HEADER_CLASSNAME,
    dbType: 'string',
    gridType: 'string',
    hidden: false,
    ignoreExpr: true,
    isTitleOrHeader: true,
    readOnly: true,
    value: rows.SECOND_ROW_TITLE,
  },
  {
    alias: rows.THIRD_ROW_ALIAS,
    className: `${HEADER_CLASSNAME} empty-date-editor`,
    dbType: 'string',
    gridType: 'string',
    hidden: false,
    ignoreExpr: true,
    isTitleOrHeader: true,
    readOnly: true,
    value: rows.THIRD_ROW_TITLE,
  },
];

export default baseRowConfig;
